/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { SelectedProfile } from './';
import {
    SelectedProfileFromJSON,
    SelectedProfileFromJSONTyped,
    SelectedProfileToJSON,
} from './';

/**
 * 
 * @export
 * @interface SelectFreelancersRequest
 */
export interface SelectFreelancersRequest {
    /**
     * 
     * @type {string}
     * @memberof SelectFreelancersRequest
     */
    advancedSearchQueryId: string;
    /**
     * 
     * @type {Array<SelectedProfile>}
     * @memberof SelectFreelancersRequest
     */
    profiles: Array<SelectedProfile>;
}

/**
 * Check if a given object implements the SelectFreelancersRequest interface.
 */
export function instanceOfSelectFreelancersRequest(value: object): value is SelectFreelancersRequest {
    if (!('advancedSearchQueryId' in value) || value['advancedSearchQueryId'] === undefined) return false;
    if (!('profiles' in value) || value['profiles'] === undefined) return false;
    return true;
}

export function SelectFreelancersRequestFromJSON(json: any): SelectFreelancersRequest {
    return SelectFreelancersRequestFromJSONTyped(json, false);
}

export function SelectFreelancersRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SelectFreelancersRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'advancedSearchQueryId': json['advancedSearchQueryId'],
        'profiles': ((json['profiles'] as Array<any>).map(SelectedProfileFromJSON)),
    };
}

export function SelectFreelancersRequestToJSON(value?: SelectFreelancersRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'advancedSearchQueryId': value['advancedSearchQueryId'],
        'profiles': ((value['profiles'] as Array<any>).map((v) => SelectedProfileToJSON(v))),
    };
}

